import SelectYear from '../components/SelectYear';
import * as actions from '../actions';
import { StoreState } from '../types/index';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

export function mapStateToProps({ query }: StoreState.All, ownProps: any) {
  return {
    selectedYear: query.filters[ownProps.filterName],
  };
}

export function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>, ownProps: any) {
  return {
    onChange: (newValue: any) => dispatch(actions.updateFilter(ownProps.filterName, newValue)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectYear);
